var Theme = Theme || {};

Theme.Iqvia = (function() {
    
    const Events = {
        IDENTITY_RESOLVED: 'iqvia.identity_resolved',
        ERROR: 'iqvia.error'
    };
    
    return {
        init: init,
        Events: Events
    };
    
    function init() {
        if (typeof IQVIA_CONFIG === 'undefined' || !IQVIA_CONFIG) {
            return;
        }
        
        if (!IQVIA_CONFIG.enabled || !IQVIA_CONFIG.apiKey) {
            return;
        }
        
        setupIqvia(IQVIA_CONFIG);
    }
    
    function setupIqvia(config) {
        window.aimDataLayer = window.aimDataLayer || [];
        function aimTag() { aimDataLayer.push(arguments); }
        
        aimTag(config.apiKey, 'pageview');
        aimTag(config.apiKey, 'signal', function (err, success) {
            if (err) {
                if (typeof SCM !== 'undefined' && SCM.EventEmitter) {
                    SCM.EventEmitter.publish(Events.ERROR, { error: err });
                }
            } else {
                if (success && success.identity_type === "AUT") {
                    if (typeof SCM !== 'undefined' && SCM.EventEmitter) {
                        SCM.EventEmitter.publish(Events.IDENTITY_RESOLVED, {
                            parameter: 'IQVIA',
                            value: success.primary_specialty_code,
                            identityType: success.identity_type,
                            fullResponse: success
                        });
                    }
                }
            }
        });
    }
})();